import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconoirNavArrowDown } from '@ey-xd/motif-icon';
import {
  MotifChipModule,
  MotifDropdownModule,
  MotifIconModule,
} from '@ey-xd/ng-motif';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'app-chip-dropdown',
  imports: [
    CommonModule,
    TranslatePipe,
    TranslateDirective,
    MotifChipModule,
    MotifIconModule,
    MotifDropdownModule,
  ],
  templateUrl: './chip-dropdown.component.html',
  styleUrl: './chip-dropdown.component.scss',
})
export class ChipDropdownComponent {
  arrowDownIcon = IconoirNavArrowDown;
  @Input() list: any = [];
  @Output() selectedData = new EventEmitter<any>();
  @Input() selectedvalue: any;
  @Input() isDisabled: boolean = false;

  ngOnChanges(changes: any): void {
    if (changes.selectedvalue) {
      this.selectedvalue = changes.selectedvalue.currentValue;
    }
    if (changes.isDisabled) {
      this.isDisabled = changes.isDisabled.currentValue;
      if (this.isDisabled) this.selectedvalue = this.list[0];
    }
    if (changes.list) {
      this.list = changes.list.currentValue;
    }
    if (this.isDisabled) this.selectedvalue = this.list[0];
  }

  constructor() {}

  selectEvent(event) {
    this.selectedvalue = event;
    this.selectedData.emit(this.selectedvalue);
  }

  getChipHoverColor(): string {
    if (this.isDisabled) return 'inherit';
    if (this.selectedvalue === 'Editor' || this.selectedvalue === 'Owner') {
      return '#27e35f';
    } else if (this.selectedvalue === 'Viewer') {
      return '#de9945';
    } else if (this.selectedvalue === 'Admin') {
      return '#ea011d';
    }
    return 'inherit';
  }

  trackByRoleName(index: number, item: any): string {
    return item.RoleName;
  }

  getVariant() {
    let status = this.selectedvalue;
    switch (status) {
      case 'Viewer':
        return 'warning';
      case 'Editor':
        return 'success';
      case 'Admin':
        return 'error';
      case 'Owner':
        return 'success';
      default:
        return null;
    }
  }
}
